import { Box, Divider, Grid, Typography, Stack, Button, CircularProgress } from '@mui/material';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useParams } from 'react-router-dom';
import useMetaData from '../../hooks/useMetaData';
import { META_DATA_MODULES, META_DATA_SUB_MODULES } from '../../utils/constants';
import GridLabels from '../VehicleTabs/GridLabels';
import { vehicleService } from '../../services/vehicles';
import { jsonPathToValue } from '../../utils/json';

function createData(name: string, calories: number, fat: number, carbs: number, protein: number) {
  return { name, calories, fat, carbs, protein };
}

const CustomerHandoff = () => {
  // use hooks
  const { reservationId } = useParams<{ reservationId: string }>();
  const metaData = useMetaData(META_DATA_MODULES.v360Page, META_DATA_SUB_MODULES.CustomerHandoff);

  console.log(metaData, 'metaData');

  // local states
  const [finalDelivery, setFinalDelivery] = useState<any>(null);

  // constants
  const deliveryFields = useMemo(
    () =>
      finalDelivery
        ? metaData?.data?.deliveryDetails?.rows?.map((row: any) => {
            const value = jsonPathToValue(finalDelivery, row.id) || '';
            return {
              label: row?.name,
              title: value || '--',
              type: row.type,
              format: row?.format,
            };
          }) || []
        : [],
    [finalDelivery, metaData]
  );

  // fetching final Delivery data
  const fetchFinalDelivery = useCallback(async () => {
    try {
      const resp = await vehicleService({ method: 'GET', url: `${reservationId}/finalDelivery` });
      setFinalDelivery(resp?.data?.data);
    } catch (error) {
      console.log(error);
    }
  }, [reservationId]);

  // lifecycle hook
  useEffect(() => {
    if (reservationId) {
      fetchFinalDelivery();
    }
  }, [reservationId, fetchFinalDelivery]);

  if (!finalDelivery)
    return (
      <Box sx={{ position: 'relative', minHeight: '250px' }}>
        <CircularProgress
          color="inherit"
          size={18}
          sx={{ position: 'absolute', left: '0', right: '0', top: '50%', margin: '0 auto' }}
        />
      </Box>
    );
  return (
    <Box>
      <Typography fontSize={20} mb={1.2} fontWeight={500} lineHeight="24px">
        {metaData?.data?.heading}
      </Typography>
      <Grid item xs={12} mb={1}>
        <Divider sx={{ borderColor: '#E9E9E9' }} />
      </Grid>
      <Box sx={{ width: '100%', my: 4 }}>
        <Typography fontSize={14} mb={1} fontWeight={500}>
          {metaData?.data?.deliveryDetails?.heading}
        </Typography>
        <Divider sx={{ borderColor: '#e3e3e3', borderStyle: 'dashed' }} />
        <Grid container spacing={2} mt={0}>
          <GridLabels
            labels={deliveryFields}
            labelSx={{ fontSize: '14px', fontWeight: '400', color: '#717171' }}
            titleSx={{ fontSize: '16px', fontWeight: '500', color: '#3E3E3E' }}
          />
        </Grid>
      </Box>
    </Box>
  );
};

export default CustomerHandoff;
